export default {
  title: "Nta Tsinda Rikora Washyizwemo",
  message:
    "Konti yawe irakora, ariko ubu nta tsinda ryo kwizigamira rikora washyizwemo.",
  help:
    "Vugana n’umuyobozi w’itsinda. Nyuma yo kugushyira mu itsinda, kanda kuri buto iri hasi kugira ngo wongere ugenzure.",
  refresh: "Ongera Ugenzure",
  checking: "Birimo kugenzurwa...",
  logout: "Sohoka",
  footer:
    "Ushobora gukomeza kwinjira mu mutekano nubwo utarashyirwa mu itsinda.",

  errors: {
    stillNoGroup:
      "Nta tsinda rikora urashyirwamo.",
    tooManyAttempts:
      "Wagerageje inshuro nyinshi. Tegereza umunota umwe wongere ugerageze.",
    checkFailed:
      "Kugenzura itsinda washyizwemo byanze. Ongera ugerageze.",
  },
};
